import { UI, Stack } from '@genial/components';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { customerItemState } from '../../../store/customer/atom';
import { DynamicAsset } from '../../BatchTicket/components/DynamicAsset';
import {
  productsWithSellConstants,
  getAllProductsEnabled,
  ProductsConstantsType,
} from '../../BatchTicket/components/DynamicAsset/constants';
import { GlobalAssetContextReceivedData } from '../../BatchTicket/components/DynamicAsset/contexts';
import { DynamicButton } from '../DynamicButton';

export interface DynamicAssetProps {
  infoGetter: GlobalAssetContextReceivedData['infoGetter'];
  CustomGlobalButton?: React.FC;
}

export const DynamicAssetWrapper = () => {
  const customerItem = useRecoilValue(customerItemState);
  const productsEnabled = getAllProductsEnabled(
    [...productsWithSellConstants] as ProductsConstantsType[],
    'unleashFlag'
  );

  if (!productsEnabled.length) {
    return (
      <Stack py="stack.huge">
        <UI.ErrorBoundary
          errorIconOrIllustration="NotEmptyIllustration"
          errorIconColor="brand.tertiary.principal"
          errorTitle="Nenhum produto disponível no momento"
          errorMessage="Caso tenha dúvidas, entre em contato com time de middle pelo e-mail middleb2b@genial.com.vc"
        />
      </Stack>
    );
  }

  return (
    <Stack px="stack.xxxs" py={{ base: 0, md: 'stack.xxxs' }}>
      <DynamicAsset
        isBatchTicket={false}
        initialTabs={productsEnabled}
        accountId={customerItem.current.accountId}
        document={customerItem.current.cpfCnpjFormatted || customerItem.current.cpfCnpj.toString()}
        accountNumber={customerItem.current.accountNumber}
        checkingAccountNumber={customerItem.current.checkingAccountNumber}
        infoGetter={() => {
          return {
            Button: DynamicButton,
          };
        }}
      />
    </Stack>
  );
};
